module.exports = __webpack_public_path__ + "img/location_sign.f15bf182.jpg";